import {Component, Input, OnInit} from '@angular/core';

import {FormComponent} from '../form';

@Component({
    selector: 'app-form-array',
    templateUrl: './form-array.component.html',
    styleUrls: ['./form-array.component.scss']
})
export class FormArrayComponent<FormsControlType = string | number> extends FormComponent implements OnInit {
    @Input() public formArraySelector: string;

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
    }
}
